module.exports = __webpack_public_path__ + "media/img/pages/profile/lidl ger 9-b086c6993d75566347a88c8646ec6cf3.webp";